import { ModalAlertComponent } from './../../../../../../modals/modal-alert/modal-alert.component';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/core/layout/services/loading.service';
import { FormGroup } from '@angular/forms';
import { NavController, ModalController } from '@ionic/angular';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
import { Component, OnInit } from '@angular/core';
import { ConsultDetranService } from '@wlp/ui-bs-detran';
import { UserInfoService } from '@wlp/ui-bs-login';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';

@Component({
  selector: 'app-consult',
  templateUrl: './consult.component.html',
  styleUrls: ['./consult.component.scss']
})
export class ConsultComponent implements OnInit {

  iconName: string | 'eye-off-outline' | 'eye-outline';
  balanceTitle: string;
  titleHeader: string;
  backgroundHeaderLogon: any;
  listStates: Array<any>
  listOperations: any;

  public consultForm: FormGroup
  public dataResult: any;
  showListDebits: boolean = false;
  userProfile: any;
  public vihecle: any;
  public isOperation: boolean = true;
  totalValue: number = 0;
  listItemSelected: [];
  disabledItensSelected: boolean = true;
  public isDataResult: boolean = true;

  constructor(
    private layoutConfigService: LayoutConfigService,
    private navController: NavController,
    private consultDetranService: ConsultDetranService,
    private load: LoadingService,
    private router: Router,
    private userInfoService: UserInfoService,
    private modalController: ModalController,
    private translate: UiBsTranslateService,
  ) { }

  ngOnInit() {
    this.iconName = 'eye-off-outline';
    this.titleHeader = 'CASH_OUT.BILLET.HEADER.TITLE';
    this.balanceTitle = 'CASH_OUT.BILLET.HEADER.SUBTITLE';
    this.backgroundHeaderLogon = this.layoutConfigService.getConfig('wlTheme.header.background.image');
    this.listStates = new Array();
    this.consultForm = this.consultDetranService.createForm();
    this.loadUser();

    if (this.router.getCurrentNavigation().extras.state == undefined) {
      this.navController.navigateRoot(['/app/payment/detran/vehicle-list']);
    } else {
      this.vihecle = this.router.getCurrentNavigation().extras.state.vehicle;
      this.getListDebit(this.vihecle.uf);
      this.consultForm.patchValue(this.vihecle);
    }
  }

  continue() {
    this.load.show()
    this.consultDetranService.setFormSubject(this.consultForm)
    this.load.hide()
    this.router.navigate(['/app/payment/detran/payment-resume-dentra'], { state: { data: this.dataResult, listItemSelected: this.listItemSelected, totalValue: this.totalValue } })
  }

  getListDebit(stateSelected) {
    this.load.show()
    this.consultDetranService.consultType(stateSelected)
      .subscribe(res => {
        if (res.statusCode === 400) {
          this.load.hide();
          this.notification('warning-circle', res.message, false);
          this.isOperation = false;
        } else {
          this.load.hide()
          this.listOperations = res;
          this.isOperation = this.listOperations.length != 0;
        }
      }, (err) => {
        this.notification('warning-circle', this.translate.applyTranslate('CASH_OUT.DETRAN.MESSAGES.FAILED_DEFAULT'), false);
        this.listOperations = [];
        this.load.hide();
      })
  }

  dismiss() {
    this.navController.navigateRoot(['/app/payment/detran/vehicle-list']);
  }

  backToVehicleList() {
    this.navController.navigateRoot(['/app/payment/detran/vehicle-list']);
  }

  nextStep() {
    this.getDebits()
  }

  getDebits() {
    this.load.show()
    this.consultDetranService.getDebits(
      this.consultForm.get('uf').value,
      this.consultForm.get('operation').value,
      this.consultForm.get('renavam').value,
      this.userProfile.uuidAccount)
      .subscribe(res => {
        this.load.hide()
        if (res.statusCode === 400 || res.statusCode === 404) {
          this.notification('warning-circle', res.message, false);
        } else {
          this.dataResult = res;
          /* 
          this.verifyTypeOperation();
          this.load.hide() */

          if (this.dataResult.debits.length === 0) {
            this.isDataResult = true;
            this.notification('warning-circle', this.translate.applyTranslate('CASH_OUT.DETRAN.MESSAGES.NOT_FOUND'), false);
          } else {
            this.showListDebits = true;
            this.isDataResult = false;
            this.verifyTypeOperation();
          }
          this.load.hide()
        }
      }),
      catchError((err) => {
        this.load.hide()
        return of(null);
      });
  }

  private loadUser() {
    try {
      const userDetails = this.userInfoService.getInfoProfile();

      userDetails.then((user) => {
        this.userProfile = user;
      });

    } catch (e) {
      console.log('Failed to load user details', e);
    }
  }

  cancel() {
    this.showListDebits = false;
  }

  private async notification(status: string, message: string, confirmation?: boolean) {
    const modalSuccess = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status,
        message,
        confirmBtn: 'OK',
        confirmation,
        translate: true,
      },
      backdropDismiss: false,
    });

    return await modalSuccess.present();
  }


  selectedOperation(item) {
    this.consultForm.controls.operation.setValue(item.code);
    this.consultDetranService.setFormSubject(this.consultForm)
    this.getDebits();
    /* this.navController.navigateRoot(['app/payment/detran/consult-result']); */
  }

  emitValue(value) {
    this.totalValue = value;
  }

  emitList(list) {
    this.listItemSelected = list;
  }
  verifyTypeOperation() {
    if (this.dataResult.service === "Licenciamento") {
      this.disabledItensSelected = false;
      this.totalValue = this.dataResult.totalValue;
    }
  }


}
